import React from 'react'
import success from "../assets/images/success.png"

function ResetPasswordSuccess() {
  return (
    <div className="pwdreset">
      <div>
        <img src={success} alt="" srcset="" />
      </div>
      <div>
        <h1>Reset Password Successful</h1>
        <p>Redirecting you to sign in page...</p>
      </div>

    </div>
  )
}

export default ResetPasswordSuccess;   